import type { NumberFormatOptions } from '@formatjs/ecma402-abstract';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { FormattedNumber } from 'react-intl';
import { SolveResultFormat } from 'state/quotes/results/result.model';
import styled from 'styled-components';

export interface SolveResultWrapperProps {
  className?: string;
  strike?: boolean;
  children: ReactNode;
}
export interface SolveResultProps extends Omit<SolveResultWrapperProps, 'children'> {
  price?: number;
  priceFormat?: SolveResultFormat;
  unit?: string;
}
export function SolveResultWrapper({ strike, className, children }: SolveResultWrapperProps) {
  return (
    <RateZone
      className={classNames('fw-medium tabular-figures', { 'text-decoration-line-through': strike }, className)}
      data-e2e="solve-result"
    >
      {children}
    </RateZone>
  );
}
export const SolveResult: FC<SolveResultProps> = ({ className, price, priceFormat, strike = false, unit }) => {
  if (price === undefined) {
    return null;
  }

  return (
    <SolveResultWrapper strike={strike} className={className}>
      <FormattedNumber
        value={price}
        maximumFractionDigits={4}
        currency={unit}
        style={mapPriceFormatToIntl(priceFormat)}
      />
    </SolveResultWrapper>
  );
};

const RateZone = styled.h1`
  font-size: 42px;
`;

function mapPriceFormatToIntl(priceFormat?: SolveResultFormat): NumberFormatOptions['style'] {
  return priceFormat === 'Percent' || priceFormat === undefined ? 'percent' : 'currency';
}
